import script from "./slideProductThree.vue?vue&type=script&setup=true&lang=js"
export * from "./slideProductThree.vue?vue&type=script&setup=true&lang=js"

import "./slideProductThree.vue?vue&type=style&index=0&id=0b463a70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b463a70"]])

export default __exports__